import React from "react";
import { DashboardListView } from "@/components/DashboardList/DashboardListView";

const DashboardListPage: React.FC = () => {
  return <DashboardListView />;
};

export default DashboardListPage;
